/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'utils/extends'
import App from './app'
import router from './router'
import store from 'store'
import accessToken from 'utils/access-token'
import { login } from 'utils/login-util'
import UserService from 'service/user-service'
// 基础组件库
import BootstrapVue from './components-base'
import 'vant/lib/dialog/style'
import 'vant/lib/toast/style'

import { Dialog } from 'vant'

Vue.use(BootstrapVue)
Vue.use(Dialog)

// 注册公共组件
import CommonComponents from 'components/common'

Object.keys(CommonComponents).forEach(key => {
  Vue.component(key, CommonComponents[key])
})

// 注册自定义组件
import CustomComponents from 'components-base/components-custom'

Object.keys(CustomComponents).forEach(key => {
  Vue.component(key, CustomComponents[key])
})

// 百度地图
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'HnHdXBblEMuVHVBnBW8PFvsUma5FSQuI'
})

// 组织结构以及拖拽
import VTree from 'vue-tree-halower'

Vue.use(VTree)

// Alert弹窗
import VueSweetAlert from 'vue-sweetalert2'

Vue.use(VueSweetAlert)

// Toast提示
import VueToasted from 'vue-toasted'

Vue.use(VueToasted, {
  iconPack: 'fontawesome' // set your iconPack, defaults to material. material|fontawesome
})

// 系统提示
import systemNotice from 'components-base/components-custom/systemNotice'

Vue.prototype.$systemNotice = systemNotice

// Awesome Notifications提示
import VueAWN from 'vue-awesome-notifications'

require('vue-awesome-notifications/dist/styles/style.css')
const AWNoptions = {
  position: 'top-right',
  duration: 2500,
  labels: {
    tip: '提示',
    info: '信息',
    success: '成功',
    warning: '警告',
    alert: '错误',
    async: '加载中',
    confirm: ''
  },
  modal: {
    okLabel: '确定',
    cancelLabel: '取消'
  },
  messages: {
    async: '请等待....'
  // 'async-block': '加载中'
  }
}
Vue.use(VueAWN, AWNoptions)

// markdown编辑器vue版本
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(mavonEditor)

// V2Table
import 'v2-table/dist/index.css'
import V2Table from 'v2-table'

Vue.use(V2Table)

// 指令
import { hasPermission } from 'src/directive'

// VeeValidate配置
import VeeValidate, { Validator } from 'vee-validate'
import messagesCN from 'utils/validate/zh_CN'

const veeConfig = {
  errorBagName: 'errors',
  delay: 500,
  locale: 'cn',
  messages: null,
  strict: true,
  dictionary: { cn: { messages: messagesCN } }
}
Vue.use(VeeValidate, veeConfig)
// 配置中文字典
const dictionary = {
  cn: {
    messages: {
      required: () => '必须填写%%%',
      email: () => '请填写正确的邮箱格式'
    }
  }
}
// Override and merge the dictionaries
Validator.localize(dictionary)
const validator = new Validator({ first_name: 'required' })
validator.localize('cn') // now this validator will generate messages in Arabic.

// 页面滚动
import VueSlimScroll from 'vue-slimscroll'

Vue.use(VueSlimScroll)

// VueAffix
import Affix from 'vue-affix'
import Scrollactive from 'vue-scrollactive'

Vue.use(Affix)
Vue.use(Scrollactive)

// 引入全局过滤器
require('common/filters/index')
import { VIEW } from 'utils/constant'

window.$router = router
router.beforeEach((sto, sfrom, next) => {
  // check login
  let { auth = true } = sto.meta
  let token = store.getters.token
  if (!token) {
    let flag = false
    if (!token) {
      flag = true
      // 用户刷新后，从localStorge 中取 token
      token = accessToken.get()
    }
    new Promise((resolve, reject) => {
      if (token) {
        resolve()
      } else {
        UserService.cas().then(res => {
          if (res && res.data && res.data.authenticated) {
            token = res.data.token
            flag = false
          }
          resolve()
        })
      }
    })
      .then(() => {
        if (!token && auth) {
          // console.log(location.href)
          login(location.href)
        } else if (auth && token) {
          store.commit('SET_TOKEN', token)
          if (flag) {
            return UserService.info().then(() => {
              return Promise.resolve()
            })
          } else {
            return Promise.resolve()
          }
        } else {
          return Promise.resolve()
        }
      })
      .then(next, () => {
        next('/404')
      })
  } else {
    next()
  }

// const {auth = true, name} = sto.meta
// let token = store.getters.token
// // 用户刷新后标记为 flag 为 true，刷新后 vuex 中内容消失，要重新设置，
// let flag = false
// if (!token) {
//   flag = true
//   // 用户刷新后，从localStorge 中取 token
//   token = accessToken.get()
// }
// new Promise((resolve, reject) => {
//   // 有 token 下一步，无 token 检查的 cas 是否登录
//   if (token) {
//     resolve()
//   } else {
//     UserService.cas().then((res) => {
//       if (res && res.data && res.data.authenticated) {
//         token = res.data.token
//         flag = false
//       }
//       resolve()
//     })
//   }
// })
//   .then(() => {
//     if (auth && !token) {
//       login(location.href)
//     } else if (auth && token) {
//       if (flag) {
//         store.commit('SET_TOKEN', token)
//         return UserService.info().then(() => {
//           if (hasPermission(`${name}:${VIEW}`)) {
//             return Promise.resolve()
//           } else {
//             return Promise.reject()
//           }
//         })
//       } else {
//         if (hasPermission(`${name}:${VIEW}`)) {
//           return Promise.resolve()
//         } else {
//           return Promise.reject()
//         }
//       }
//     } else {
//       return Promise.resolve()
//     }
//   })
//   .then(next, () => {
//     next('/404')
//   })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App}
})
if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = function (err, vm, info) {
    var componentName = formatComponentName(vm)
    var propsData = vm.$options && vm.$options.propsData
    // eslint-disable-next-line no-undef
    fundebug.notifyError(err, {
      metaData: {
        componentName: componentName,
        propsData: propsData,
        info: info
      }
    })
  }
  function formatComponentName (vm) {
    if (vm.$root === vm) return 'root'

    var name = vm._isVue
      ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
      : vm.name
    return (
      (name ? 'component <' + name + '>' : 'anonymous component') +
      (vm._isVue && vm.$options && vm.$options.__file
        ? ' at ' + (vm.$options && vm.$options.__file)
        : '')
    )
  }
}



// WEBPACK FOOTER //
// ./src/main.js